import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class FormService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getForms() {
    return this.http.get(
      `${this.baseUrl}/v1/forms`
    );
  }
}